const enum UserPermissions {
  ASSIGN_DRIVERS_TO_ROUTES = 'ASSIGN_DRIVERS_TO_ROUTES',
  ASSIGN_STOPS_TO_ROUTES = 'ASSIGN_STOPS_TO_ROUTES',
  CLOSE_SUPPORT_SESSION = 'CLOSE_SUPPORT_SESSION',
  COMPLETE_VISITS = 'COMPLETE_VISITS',
  CREATE_DRIVERS = 'CREATE_DRIVERS',
  CREATE_PROJECTS = 'CREATE_PROJECTS',
  CREATE_ROUTES = 'CREATE_ROUTES',
  CREATE_ROUTE_TEMPLATES = 'CREATE_ROUTE_TEMPLATES',
  CREATE_ROUTE_TERRITORIES = 'CREATE_ROUTE_TERRITORIES',
  CREATE_USER_WITH_ROLE = 'CREATE_USER_WITH_ROLE',
  CREATE_VISITS = 'CREATE_VISITS',
  CREATE_CUSTOMERS = 'CREATE_CUSTOMERS',
  CREATE_SERVICE_ACCOUNTS = 'CREATE_SERVICE_ACCOUNTS',
  DELETE_CUSTOMERS = 'DELETE_CUSTOMERS',
  DELETE_DRIVERS = 'DELETE_DRIVERS',
  DELETE_PROJECTS = 'DELETE_PROJECTS',
  DELETE_ROUTES = 'DELETE_ROUTES',
  DELETE_ROUTE_TEMPLATES = 'DELETE_ROUTE_TEMPLATES',
  DELETE_ROUTE_TERRITORIES = 'DELETE_ROUTE_TERRITORIES',
  DELETE_TEAM_MEMBERS = 'DELETE_TEAM_MEMBERS',
  DELETE_USERS = 'DELETE_USERS',
  DELETE_VISITS = 'DELETE_VISITS',
  DISPATCH_ROUTES = 'DISPATCH_ROUTES',
  DOWNLOAD_SOLUTION = 'DOWNLOAD_SOLUTION',
  EDIT_CSV_MAPPINGS = 'EDIT_CSV_MAPPINGS',
  EDIT_CUSTOMERS = 'EDIT_CUSTOMERS',
  EDIT_DRIVERS = 'EDIT_DRIVERS',
  EDIT_USERS_AS_ADMIN = 'EDIT_USERS_AS_ADMIN',
  EDIT_DRIVERS_LOCATION = 'EDIT_DRIVERS_LOCATION',
  EDIT_ROUTES = 'EDIT_ROUTES',
  EDIT_ROUTE_TEMPLATES = 'EDIT_ROUTE_TEMPLATES',
  EDIT_ROUTE_TERRITORIES = 'EDIT_ROUTE_TERRITORIES',
  EDIT_SUGGESTIONS = 'EDIT_SUGGESTIONS',
  EDIT_TEAM_MEMBERS = 'EDIT_TEAM_MEMBERS',
  EDIT_VISITS = 'EDIT_VISITS',
  INVITE_DRIVERS = 'INVITE_DRIVERS',
  READ_OPTIMIZATION = 'READ_OPTIMIZATION',
  START_SUPPORT_SESSION = 'START_SUPPORT_SESSION',
  STORE_DRIVERS_TOKEN = 'STORE_DRIVERS_TOKEN',
  VIEW_CSV_MAPPINGS = 'VIEW_CSV_MAPPINGS',
  VIEW_DRIVERS = 'VIEW_DRIVERS',
  VIEW_INSIGHTS = 'VIEW_INSIGHTS',
  VIEW_PERMISSIONS = 'VIEW_PERMISSIONS',
  VIEW_PROJECTS = 'VIEW_PROJECTS',
  VIEW_ROUTES = 'VIEW_ROUTES',
  VIEW_ROUTE_TEMPLATES = 'VIEW_ROUTE_TEMPLATES',
  VIEW_ROUTE_TERRITORIES = 'VIEW_ROUTE_TEMPLATES',
  VIEW_SOLUTIONS = 'VIEW_SOLUTIONS',
  VIEW_SUGGESTIONS = 'VIEW_SUGGESTIONS',
  VIEW_UNSCHEDULED_VISITS = 'VIEW_UNSCHEDULED_VISITS',
  VIEW_MY_USER = 'VIEW_MY_USER',
  VIEW_TEAM_MEMBERS = 'VIEW_TEAM_MEMBERS',
  VIEW_TEAM_MEMBER_UPDATES = 'VIEW_TEAM_MEMBER_UPDATES',
  VIEW_USERS_AS_ADMIN = 'VIEW_USERS_AS_ADMIN',
  VIEW_VISITS = 'VIEW_VISITS',
  VIEW_CUSTOMERS = 'VIEW_CUSTOMERS',
  VIEW_PLANNING_ACTIONS = 'VIEW_PLANNING_ACTIONS',
  UNDO_REDO_ACTION = 'UNDO_REDO_ACTION',
  SEGMENT_TRACKING = 'SEGMENT_TRACKING',
  CREATE_OPTIMIZATION = 'CREATE_OPTIMIZATION',
  ACCEPT_DISPATCHER_INVITATION = 'ACCEPT_DISPATCHER_INVITATION',
  UPDATE_USER_PASSWORD_AS_ADMIN = 'UPDATE_USER_PASSWORD_AS_ADMIN',
  VISUALIZE_LEGACY_JOBS = 'VISUALIZE_LEGACY_JOBS',
  VIEW_ORGANIZATION = 'VIEW_ORGANIZATION',
  VIEW_NOTIFICATION_LOGS = 'VIEW_NOTIFICATION_LOGS',
  VIEW_CUSTOMER_NOTIFICATION_SETTINGS = 'VIEW_CUSTOMER_NOTIFICATION_SETTINGS',
  EDIT_CUSTOMER_NOTIFICATION_SETTINGS = 'EDIT_CUSTOMER_NOTIFICATION_SETTINGS',
  EDIT_ORGANIZATION_SETTINGS = 'EDIT_ORGANIZATION_SETTINGS',
  EDIT_ORGANIZATION_PROFILE = 'EDIT_ORGANIZATION_PROFILE',
  ENABLE_SMS_NOTIFICATION = 'ENABLE_SMS_NOTIFICATION',
  EDIT_PROJECTS = 'EDIT_PROJECTS',
  VIEW_WORKSPACE_SETTINGS = 'VIEW_WORKSPACE_SETTINGS',
  EDIT_WORKSPACE_SETTINGS = 'EDIT_WORKSPACE_SETTINGS',
  VIEW_ORGANIZATION_SETTINGS = 'VIEW_ORGANIZATION_SETTINGS',
  INVITE_NEW_MEMBERS = 'INVITE_NEW_MEMBERS',
  VIEW_BILLING = 'VIEW_BILLING',
  EDIT_BILLING = 'EDIT_BILLING',
  VIEW_ANALYTICS = 'VIEW_ANALYTICS',
  VIEW_SERVICE_ACCOUNTS = 'VIEW_SERVICE_ACCOUNTS',
  MANAGE_SHOPIFY_ACCOUNT = 'MANAGE_SHOPIFY_ACCOUNT',
  MANAGE_WEBHOOKS = 'MANAGE_WEBHOOKS',
  VIEW_WEBHOOKS = 'VIEW_WEBHOOKS',
}

export default UserPermissions;
